// 高德地图 key
export const MapKey = 'cfd8da5cf010c5f7441834ff5e764f5b'
    // 地图限定城市
export const MapCityName = '上海'